<template>
  <div class="flex flex-col gap-6">
    <div v-if="store.state.preInterest == VorauswahlInteresse.FÜHRERSCHEIN">
      <h3 class="h3">Führerschein Informationen</h3>
      <div class="default-grid">
        <div class="pi-info-block">
          <h4 class="h4">Führerschein</h4>
          <span>{{ store.state.preDriverLicence }}</span>
        </div>
        <div class="pi-info-block" v-if="store.state.preDriverLicence == VorauswahlFührerschein.JA && !store.state.preDriverLicenceDetailsSkip">
          <h4 class="h4">Führerscheinnummer</h4>
          <span>{{ store.state.preDriverLicenceDetails.number }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Ausgewählte Klassen</h4>
          <span>{{ store.state.newDriverLicenceClasses.join(', ') }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Ausgewählte Kurse</h4>
          <div v-for="course in store.state.selectedCourses" :key="course.id">
            <span v-if="/^-?\d+$/.test(course.id)">{{ course.from }} - {{ course.to }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 class="h3">Trainings Informationen</h3>
      <div class="default-grid">
        <div class="pi-info-block">
          <h4 class="h4">Ausgewähltes Training</h4>
          <span>{{ selectedTraining.date }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Ausgewählter Trainingstyp</h4>
          <span>{{ store.state.selectedVehicletype }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Fahrzeug leihen</h4>
          <span>{{ store.state.borrowVehicle }}</span>
        </div>
      </div>
    </div>

    <div>
      <h3 class="h3">Anschrift</h3>
      <div class="default-grid">
        <div class="pi-info-block">
          <h4 class="h4">Straße</h4>
          <span>{{ pi.street }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Postleitzahl</h4>
          <span>{{ pi.postalcode }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Hausnummer</h4>
          <span>{{ pi.housenumber }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Ort</h4>
          <span>{{ pi.city }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Land</h4>
          <span>{{ getCountryNameByCode(pi.country) }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Staatsbürgerschaft</h4>
          <span>{{ getCountryNameByCode(pi.citizenship) }}</span>
        </div>
      </div>
    </div>

    <div>
      <h3 class="h3">Kontaktdaten</h3>
      <div class="default-grid">
        <div class="pi-info-block">
          <h4 class="h4">E-Mail Adresse</h4>
          <span>{{ pi.email }}</span>
        </div>
        <div class="pi-info-block">
          <h4 class="h4">Telefonnummer</h4>
          <span>{{ pi.phone }}</span>
        </div>
      </div>
    </div>

    <div>
      <h3 class="h3">Datenschutz</h3>
      <div class="flex gap-5 items-center">
        <input id="acceptDataPrivacy" type="checkbox" v-model="acceptDataPrivacy">
        <label for="acceptDataPrivacy" class="text-slate-500">Hiermit bestätige ich, dass die Fahrschule Steininger meine Daten zweckgebunden verarbeiten und mich zur Erbringung der Dienstleistung kontaktieren darf. Weitere Informationen dazu finden sich in der ausführlichen Datenschutzerklärung.</label>
      </div>
    </div>

    <div class="flex justify-between mt-5 items-center">
      <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
      <input type="button" class="button next" :disabled="nextDisabled" value="Anmeldung absenden" @click="next"/>
    </div>
    <div class="text-center">
      <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
    </div>
  </div>
</template>
<!-- eslint-disable no-unused-vars -->
<script setup>
import { Navigation, VorauswahlFührerschein, VorauswahlInteresse } from '../models/enums'
import { getCountryNameByCode, scrollToTop } from '../models/helper'
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const pi = store.state.pi
const selectedTraining = store.state.selectedTraining

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  if(store.state.preInterest == VorauswahlInteresse.FÜHRERSCHEIN)
    store.dispatch("SEND_COURSE_APPLICATION");
  else if (store.state.preInterest == VorauswahlInteresse.FAHRSICHERHEITSTRAINING)
    store.dispatch("SEND_TRAINING_APPLICATION");

  scrollToTop();
}
const nextDisabled = computed(() => !store.state.acceptDataPrivacy);
const acceptDataPrivacy = computed({
  get: () => store.state.acceptDataPrivacy,
  set: value => store.commit("updateAcceptDataPrivacy", value)
});
</script>

<style scoped lang="scss">
h3, h4 {
  @apply mb-2;
}
.pi-info-block {
  @apply flex flex-col mb-4;
  span {
    @apply text-slate-500;
  }
}
.default-grid {
  @apply grid md:grid-cols-2;
}
</style>
